import { useState, useRef, Fragment } from "react";
import Config from "../../Config";
import Calendar from "../../calendar/Calendar";
import InputComboGrupaE from "../../helpers/InputComboGrupaE";
import InputText from "../../helpers/InputText";
import InputTextArea from "../../helpers/InputTextArea";
import InputCombo from "../../helpers/InputCombo";
import MenuTable from "../../helpers/MenuTable";
import Csv from "../../exporter/Csv";
import Print from "../../exporter/Print";
import InputTime from "../../helpers/InputTime";



function CalendarYearE(props)
{

   const [errTab, setErrTab] = useState([]);  //z info od serwera..

   const [refreshView, setRefreshView] = useState(props.userData.refreshView);
   const [tab, setTab] = useState(null);

   const [list, setList] = useState(null);

   const tabRef = useRef(0); //do druku

 

   var dt = new Date();

   var strM = (dt.getMonth()+1)+"";
   if(strM.length == 1) strM = "0" + strM;

   var strD = dt.getDate()+"";
   if(strD.length == 1) strD = "0" + strD;

   var dateX  = dt.getFullYear()+"-"+strM+"-"+strD;

   
   const [view, setView] = useState('list');


   
   const [filter, setFilter] = useState(null);
   const [filterParam, setFilterParam] = useState({   
                
       p_grupa_id:  '_x_',
       day: dateX,

       limit: 50,
       page: 1,
       pages: 1,
   });


 
   const clickOnDay = (date,title) => {      
      
      if( date != null && date.length > 2)
      {
         //setFilterParam({...filterParam, ["day"]: date,["p_grupa_id"]:'_x_' });                  
         setFilterParam({...filterParam, ["day"]: date,["p_grupa_id"]:'_x_' });    

         getList(date);
      }
    

  }



   const valChangeListener = (filedName, val, correct, msg) => {

      //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

      setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );
      
      
      var modX = val.length % 3;
      if(  val.length == 0 || modX == 0 || msg =='combo')
      setTab();  

      props.mainView.writeFilter(filedName, val);
   }


   const valChangeListenerForm = (filedName, val, correct, msg) => {

      //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

      setTab( {...tab, [filedName]:val,  [filedName+"_valid"]:correct } );      
      props.mainView.writeFilter(filedName, val);
   }


   const goNextNew = () => {
      console.log("goNext");    
      setTab(null);    
   }





   const getTab = (gId, d) => {
        

     if(filterParam.p_grupa_id == "_x_") return;

      props.mainView.setProgress(-2);     

      fetch( Config.url + '/rest_v1_news,kalendarz', {
          method: 'POST', 
          body: JSON.stringify(filterParam), 
          headers: {
              'Content-Type': 'application/json',                    
              'X-Api-Key': props.userData.apiKey,
              '_p_przedszkole_id_': props.userData.p_przedszkole_id,
              '_p_dziecko_id_': props.userData.p_dziecko_id,
              '_sec_key_': Config.genXKey() ,
          }
       })
       .then(res => res.json() )
       .then(res => { 

                  props.mainView.setProgress(-1);        
                  if(res._sys_ == undefined)
                  {
                      props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                  }else
                  if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                  {
                      props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                  }else    
                  {
                      setTab(res.result);   
                      getList(null);                                                                        
                  }
       } )
       .catch(err => {          
                  props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                  props.mainView.setProgress(-1);
       });
                 

       return false;
  }


  const getList = (dt ) => {
        

   var req = {
      ym: filterParam.day
   };

   if(dt != null )
   {
      req = {
         ym: dt
      };
   }


    props.mainView.setProgress(-2);     

    fetch( Config.url + '/rest_v1_employessModule,kalendarz_list', {
        method: 'POST', 
        body: JSON.stringify(req), 
        headers: {
            'Content-Type': 'application/json',                    
            'X-Api-Key': props.userData.apiKey,
            '_p_przedszkole_id_': props.userData.p_przedszkole_id,
            '_p_dziecko_id_': props.userData.p_dziecko_id,
            '_sec_key_': Config.genXKey() ,
        }
     })
     .then(res => res.json() )
     .then(res => { 

                props.mainView.setProgress(-1);        
                if(res._sys_ == undefined)
                {
                    props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                }else
                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                {
                    props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                }else    
                {
                    setList(res.result);      
                          
                   
                }
     } )
     .catch(err => {          
                props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                props.mainView.setProgress(-1);
     });
               

     return false;
}



  const valChecker = (fields) => {

   var allValid = true;

         
   console.log(JSON.stringify(fields) );

   Object.entries(fields).forEach(function(entry) {

       var xKey    = entry[0];
       var xValue  = entry[1];                    

       var xValidName = xKey + "_valid";

       if(fields[xValidName] == false)
       {
           allValid = false;
           console.log("Error field: " + xKey);
       }
       
     });
   
     return allValid;

}

  const saveData = () => {


   if(!valChecker(tab))
      {
          props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_gocorrect  ,  "ok"  ,null); 
          return;
      }

 

            props.mainView.setProgress(-2);     

            fetch( Config.url + '/rest_v1_news,kalendarz_zapisz', {
               method: 'POST', 
               body: JSON.stringify(tab), 
               headers: {
                  'Content-Type': 'application/json',                    
                  'X-Api-Key': props.userData.apiKey,
                  '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                  '_p_dziecko_id_': props.userData.p_dziecko_id,
                  '_sec_key_': Config.genXKey() ,
               }
            })
            .then(res => res.json() )
            .then(res => { 

                        props.mainView.setProgress(-1);        
                        if(res._sys_ == undefined)
                        {
                           props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                        }else
                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                        {
                           props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                        }else    
                        {
                             if(res.status != undefined && res.status == "OK")
                              {
                                  props.mainView.showDialog( "Sukces",  "Pozycja została dodana", "ok" , null);                                     
                                 /// props.onBack(res.result);
                              }else
                              {
                                  props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                              }
                           
                        }
            } )
            .catch(err => {          
                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                        props.mainView.setProgress(-1);
            });
                  

  }


   const goDelete = (e) => {

      var id = e.target.getAttribute("id");
   
      props.mainView.setProgress(-2);

        var req = {
            id: id
        }

        fetch( Config.url + '/rest_v1_news,kalendarz_del', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {             
                    
                    props.mainView.setProgress(-1);

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", "Something is wrong: ext:" + JSON.stringify(res) , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == "OK")
                    {
                        props.mainView.showDialog( "Sukces",  "Wpis został usunięty", "ok" , null);                        
                        setTab(null);
                        setList(null);
                    }else
                    {
                        props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                    }
                   
         } )
         .catch(err => {   
                    props.mainView.setProgress(-1);       
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
         });
        

   }



   var daysReview = new Array();

   daysReview.push({
         date: filterParam.day,
         title: "wybrano " + filterParam.day,
         className: "selected",
   });


   
   var dayContent = null;



   if(refreshView != props.userData.refreshView)
      {         
          setRefreshView( props.userData.refreshView);
          setTab(null);
          setFilterParam({...filterParam,["p_grupa_id"]:"_x_" });
      }


      if(tab == null)
      {
         setTab([]);
         getTab();       
      }


      if(list == null)
      {
         setList([]);
         getList(null);
         return <div></div>
      }


   if(filterParam.day.length > 2)
   {
         dayContent = <div>

               <div className="table_filter">
                             <div className="filter_controll">   
                                <label>Grupa: </label>                             
                                <InputComboGrupaE   userData={props.userData}  mainView={props.mainView}  value={filterParam.p_grupa_id}   valChange={valChangeListener} goNext={goNextNew} name="p_grupa_id" placeholder={": "}   />
                            </div> 
               </div>

         </div>
   }  


   var tn = [
      { v: 0, title: 'Nie' }, 
      { v: 1, title: 'Tak, dzień wcześniej (rano) ' }, 
   ];

   var tnX = [
      { v: 0, title: 'Nie' }, 
      { v: 1, title: 'Tak ' }, 
   ];

   return   <div className="view_content">
 


                           <div className="bg_center">

                                             

                           <div className="block50">

                                 <Calendar tab={daysReview} clickOnDay={clickOnDay} />

                           </div>


                           <div className="block50">
                              
                              <div className="calColor">Zaplanowane wydarzenia na {filterParam.day}</div>

                          
                              {dayContent}
                                
                       

                              {
                                 tab != null && tab.id != undefined &&
                                 <Fragment>

                                       <form className="eForm bg_center">

                                           <div className="form_control">
                                                   <div className="fieldName">Zapisać informacje dla <b>wszystich grup</b>?</div>
                                                   <InputCombo items={tnX}   userData={props.userData} value={tab.all} err={errTab}  valChange={valChangeListenerForm} goNext={goNextNew} name="all" placeholder={":"} className=' w300 ' req='0' firstUp="0" />
                                             </div>
                                             
                                             <div className="form_split"></div>

                                             <div className="form_control">
                                                <div className="fieldName">Godzina</div>
                                                <InputTime   userData={props.userData} value={tab.godzina_wydarzenia} err={errTab}  valChange={valChangeListenerForm} goNext={goNextNew} name="godzina_wydarzenia" placeholder={"Godzina:"} className='  ' req='0' firstUp="0" />
                                             </div> 
                                             
                                             <div className="form_split"></div>

                                             <div className="form_control">
                                                   <div className="fieldName">Tytuł* (np. wyjście na spacer)</div>
                                                   <InputText   userData={props.userData} value={tab.temat_dnia} err={errTab}  valChange={valChangeListenerForm} goNext={goNextNew} name="temat_dnia" placeholder={"Tytuł:"} className=' w300 ' req='1' firstUp="0" />
                                             </div>

                                             <div className="form_control">
                                                   <div className="fieldName">Forma aktywności</div>
                                                   <InputTextArea   userData={props.userData} value={tab.forma_aktywnosci} err={errTab}  valChange={valChangeListenerForm} goNext={goNextNew} name="forma_aktywnosci" placeholder={"Forma aktywności:"} className=' w300 ' req='0' firstUp="0" />
                                             </div>

                                             <div className="form_control">
                                                   <div className="fieldName">Cel dnia</div>
                                                   <InputTextArea   userData={props.userData} value={tab.cel_dnia} err={errTab}  valChange={valChangeListenerForm} goNext={goNextNew} name="cel_dnia" placeholder={"Forma aktywności:"} className=' w300 ' req='0' firstUp="0" />
                                             </div>


                                             <div className="form_control">
                                                   <div className="fieldName">Wymagane (ciepłe ubranie, buty na przebranie, ...)</div>
                                                   <InputTextArea   userData={props.userData} value={tab.wymagane} err={errTab}  valChange={valChangeListenerForm} goNext={goNextNew} name="wymagane" placeholder={"Wymagane:"} className=' w300 ' req='0' firstUp="0" />
                                             </div>

                                             <div className="form_control">
                                                   <div className="fieldName">Przypomnienie dla rodziców</div>
                                                   <InputCombo items={tn}   userData={props.userData} value={tab.przypomnij_dzien_przed} err={errTab}  valChange={valChangeListenerForm} goNext={goNextNew} name="przypomnij_dzien_przed" placeholder={":"} className=' w300 ' req='0' firstUp="0" />
                                             </div>

                                           

                                             <div className="form_split"></div>

                                            <div className="form_btn">
                                                    <div className="btn" onClick={saveData}>zapisz</div>                                                    
                                            </div>

                                       </form>

                                 </Fragment> 
                              }

                           </div>

                              
                           {
                              list.length > 0 &&
                              <Fragment>

                                       <div className="table_widget">

                                       <Csv tabRef={tabRef} />

                                       <Print tabRef={tabRef} />
                                       
                                       </div>


                                       <table className="table" ref={tabRef} >

                                       <thead>
                                                <tr className="header">
                                                      <td className="td_left">LP</td>
                                                      <td>Dzień</td>
                                                      <td>Temat</td>
                                                      <td>Forma aktywności</td>
                                                      <td>Cel dnia</td>
                                                      <td>Uwagi</td>
                                                      <td>Wymagane</td>
                                                      <td className="td_right">Powiązane grupy</td>
                                                                                                                                       
                                                      <td className="td_option"> </td>
                                                   
                                                </tr>
                                             </thead>

                                          {
                                             list.map( ( row, ix ) => {

                                                   var rowStyle = " row ";
                                                   if(ix % 2 == 0 )rowStyle = " row2 ";

                                                   return <tr className={rowStyle} key={ix}>
                                                         <td className="gocenter">{ix+1}</td>
                                                         <td className="gocenter">  <div className="calColor">{row.dzien}</div></td>
                                                         <td>{row.temat_dnia}</td>
                                                         <td>{row.forma_aktywnosci}</td>
                                                         <td>{row.cel_dnia}</td>
                                                         <td>{row.uwagi_dodatkowe}</td>
                                                         <td>{row.wymagane}</td>                                                   
                                                         <td className="gocenter">
                                                            {
                                                               row.grupy.map( (gg, gi) => {
                                                                  return <span>
                                                                     {gg.nazwa}, &nbsp;
                                                                  </span>
                                                               } )
                                                            }
                                                         </td>                                                   
                                                         <MenuTable>
                                                            <ul>                                                                      
                                                               <li onClick={goDelete}  id={row.id} >usuń</li>
                                                            </ul>
                                                         </MenuTable>
                                                   </tr>

                                             } )
                                          }

                                       </table>


                              </Fragment>
                           }      

                              
                               
                           </div>

   </div>
}

export default CalendarYearE;